/*!
*
*
* VERSION: 1.0.0
* DATE: 2018-11-15
* @author: Jon Chandler, jonc@mcsaatchi.com
*
*
**/

if (!Array.from) {
  Array.from = function (children) {
    return Array.prototype.slice.call(children)
  };
}

import { addMenu } from './utils.js'
import { addImage, voteImage, getData } from './data.js'
import { getInstagramData } from './instagram.js'
import { postImage } from './add-content.js'
import { popGallery } from './slide-show.js'
import { aboutPageGrid } from './about-page-grid.js'


import { emotionDetection } from './emotion-detection.js'

const qsParams = new URLSearchParams(window.location.search)
const displayMode = qsParams.get('mode')
const body = document.getElementsByTagName('body')[0]
body.classList.add(displayMode)

const formEl = document.querySelector('.js-post-image')
postImage(formEl)

const menu = document.querySelector("#js-burger");
addMenu(menu);

const aboutGrid = document.querySelector('.js-image-grid')
aboutPageGrid(aboutGrid)

//const adminDomain = 'http://localhost/admin.html'
const adminDomain = 'http://admin.visualdiet.co.uk'

const clientID = '364717c981ca4429a48e9ed5ccfbc76a' // M&C
//const clientID = 'f9bbea20bbe14c26bdf19f28d7111f70' // VISUALDIET

window.accessKey = (!!window.location.hash.substr(1)) ? window.location.hash.substr(1) : undefined


if (window.location.pathname === '/admin.html' || window.location.hostname.includes('admin.')) {
  if (!accessKey) {
    window.location = `https://instagram.com/oauth/authorize/?client_id=${clientID}&redirect_uri=${adminDomain}&response_type=token`
  } else {
    getData('admin')
  }

  body.classList.add('admin')

} else if (window.location.pathname === '/emotion.html') {
  const emotionCam = document.getElementById('camera')
  emotionDetection(emotionCam)
} else {
  getData()
}


// WEBPACK FOOTER //
// ./js/main.js